import { render, staticRenderFns } from "./ModalOrderUpdate.vue?vue&type=template&id=138cf778&scoped=true&"
import script from "./ModalOrderUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalOrderUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderUpdate.vue?vue&type=style&index=0&id=138cf778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cf778",
  null
  
)

export default component.exports